import { render, staticRenderFns } from "./BoxAnalitycsLite.vue?vue&type=template&id=9434a536&scoped=true&lang=pug&"
import script from "./BoxAnalitycsLite.vue?vue&type=script&lang=ts&"
export * from "./BoxAnalitycsLite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9434a536",
  null
  
)

export default component.exports